/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';
import type { TranslationResponse } from './TranslationResponse';
import {
    TranslationResponseFromJSON,
    TranslationResponseFromJSONTyped,
    TranslationResponseToJSON,
    TranslationResponseToJSONTyped,
} from './TranslationResponse';

/**
 * 
 * @export
 * @interface TranslationResponsePagedResult
 */
export interface TranslationResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof TranslationResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<TranslationResponse>}
     * @memberof TranslationResponsePagedResult
     */
    data: Array<TranslationResponse> | null;
}

/**
 * Check if a given object implements the TranslationResponsePagedResult interface.
 */
export function instanceOfTranslationResponsePagedResult(value: object): value is TranslationResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function TranslationResponsePagedResultFromJSON(json: any): TranslationResponsePagedResult {
    return TranslationResponsePagedResultFromJSONTyped(json, false);
}

export function TranslationResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(TranslationResponseFromJSON)),
    };
}

export function TranslationResponsePagedResultToJSON(json: any): TranslationResponsePagedResult {
    return TranslationResponsePagedResultToJSONTyped(json, false);
}

export function TranslationResponsePagedResultToJSONTyped(value?: TranslationResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(TranslationResponseToJSON)),
    };
}

